import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { PaginatedResponse } from './paginated-response.interface';
import { LeagueNews, LeagueNewsType } from '../models/league-news';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class LeagueNewsApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {
  }

  async getLeagueNewsList(leagueId: number, page: number, size: number, type: LeagueNewsType = LeagueNewsType.text, seasonId?: number): Promise<PaginatedResponse<LeagueNews[]>> {
    let params = new HttpParams().set('page', page.toString())
      .set('size', size.toString())
      .set('type', LeagueNewsType[type]);
    if (seasonId) {
      params = params.set('season', seasonId.toString());
    }
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/news/`, {params, observe: 'response'})
      .pipe(map(response => ({
        total: +response.headers.get('X-Page-Count'),
        data: LeagueNews.toFront(response.body)
      })))
      .toPromise();
  }

  async getMainLeagueNews(leagueId: number): Promise<LeagueNews> {
    return this.httpClient.get<any[]>(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/news/?is_main=true`)
      .pipe(map(response => response && response.length > 0 ? LeagueNews.toFront(response[0]) : null))
      .toPromise();
  }

  async getMainLeagueNewsList(leagueId: number): Promise<LeagueNews[]> {
    return this.httpClient.get<any[]>(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/news/?is_main=true`)
      .pipe(map(response => LeagueNews.toFront(response)))
      .toPromise();
  }

  async getNewsById(newsId: number): Promise<LeagueNews> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_news/${newsId}/`)
      .pipe(map(response => LeagueNews.toFront(response)))
      .toPromise();
  }

  async getTournamentNewsList(tournamentId: number): Promise<PaginatedResponse<LeagueNews[]>> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/news/`, {observe: 'response'})
      .pipe(map(response => ({
        total: +response.headers.get('X-Page-Count'),
        data: LeagueNews.toFront(response.body)
      })))
      .toPromise();
  }
}
